import { GridColumn } from "@syncfusion/ej2-react-grids";
import React from "react";
import { GridInstanceContext } from "../PrimaryGrid/SecondaryGrid";
import { get } from "lodash";
import { BaseFieldProps, CoreFieldProps, CoreFieldValue } from "../../Fields/types/fieldTypes";
import { ColumnModel } from "@syncfusion/ej2-react-grids";

interface GridFieldColumnOptions<TModel extends object, T extends BaseFieldProps<CoreFieldValue>> extends ColumnModel {
  fieldId: string;
  fieldComponent: Partial<React.FC<Partial<T>>>;
  fieldProps: Omit<T, "onSubmit">;
  fieldOnValueChange?: (currentRecordData: TModel, newValue: CoreFieldValue) => void;
}

export default class GridFieldColumn<TModel extends object, T extends BaseFieldProps<CoreFieldValue>> extends GridColumn {
  constructor(opts: GridFieldColumnOptions<TModel, T>) {
    const { ...superOpts } = opts;

    super({
      ...superOpts,
      customAttributes: {
        ...superOpts.customAttributes,
        ...{'no-clickable': true }
      },
      template: ((data: TModel)  => {
        const gridInstance = React.useContext(GridInstanceContext);
        const isDisabled = (
          get(gridInstance, "htmlattributes") as unknown as {
            readOnly: boolean;
          }
        )?.readOnly;

        const FieldComponent = superOpts.fieldComponent as React.FC<
          Partial<CoreFieldProps>
        >;

        return (
          <FieldComponent {...superOpts.fieldProps} label="" disabled={isDisabled} value={get(data, superOpts.fieldId ?? "")} onSubmit={(newValue: CoreFieldValue) => {
            superOpts.fieldOnValueChange?.(data, newValue);
          }} />
        );
      }) as any,
    });
  }
}
 